import type { RefObject } from 'react';

import { useScrollPinning } from '#/components/layout/CategoryNavigation/useScrollPinning';
import { useMediaQuery } from '#/hooks/useMediaQuery';
import { DESKTOP_BREAKPOINT_QUERY } from '#/lib/breakpoints';

// Activate as the in-place summary slides under the mobile sticky stack (pinned
// category nav + section nav bar); the higher release threshold is a hysteresis
// band so the condensed row doesn't flap at the boundary.
const CONDENSED_SUMMARY_ACTIVATE_AT = 144;
const CONDENSED_SUMMARY_RELEASE_AT = 168;

/**
 * Shows the condensed ticker summary in the sticky nav on mobile once the
 * in-place summary box (`priceSummaryRef`) has scrolled beneath the nav stack.
 *
 * The ref is created by the page (which renders the summary box); the hook is
 * called from DetailSectionNav so the pinned-state toggle re-renders only the
 * nav subtree, not the page.
 */
export function useCondensedTickerSummary(
  priceSummaryRef: RefObject<HTMLElement | null>,
) {
  const isDesktop = useMediaQuery(DESKTOP_BREAKPOINT_QUERY);

  return useScrollPinning({
    sentinelRef: priceSummaryRef,
    enabled: isDesktop === false,
    activateAt: CONDENSED_SUMMARY_ACTIVATE_AT,
    releaseAt: CONDENSED_SUMMARY_RELEASE_AT,
    schedule: 'animationFrame',
  });
}
